import { render, staticRenderFns } from "./ClubIndex.vue?vue&type=template&id=684a5740&scoped=true"
import script from "./ClubIndex.vue?vue&type=script&lang=js"
export * from "./ClubIndex.vue?vue&type=script&lang=js"
import style0 from "./ClubIndex.vue?vue&type=style&index=0&id=684a5740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a5740",
  null
  
)

export default component.exports